import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { MUSEUM_GEO } from './museumgeo.ts';

/**
 * The Museum: a night-time heist through a natural history and art museum. Four wings (antiquities with a jewel vault, and
 * galleries with a gift shop, each turned half a turn) round a marble cross of great halls and a central rotunda, where two
 * skeleton plinths stand either side of zone B. The west half is drawn here; the east half is its half-turn.
 *
 * W gallery wall, M marble pier, G glass display case, C shop counter. Round columns, the dinosaur plinth, wing doors and roofs are
 * polygons (museumgeo.ts); the cells they replaced are empty here.
 */
const MUSEUM_GRID = gridMap('Museum', `
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ........WWWWWWWWWWWWWWWWWW....WWWWWWWWWWWWWWWWWWWW..........
  ........W...............................WWWWWWWWWW..........
  ........W.FFFFF.........................W.......WW..........
  ........W.FFFFF.........................W.GG.GG.WW..........
  ........W.FFFFF.........GGGGGGGGGG......W.......WW....FFFFF.
  ........W.FFFFF...GG............................WW....FFFFF.
  ........W.FFFFF...GG........................G...WW....FFFFF.
  ........W.........GG....................W...G...WW....FFFFF.
  ........W.........GG....................W.......W.....FFFFF.
  ........W.........GG....................W.......W...........
  ........W.........GG....e...............W.......W...........
  ........W.........GG....................WWW....WW...........
  ........W.........GG......c......................W.l....c...
  ........W........................................W..........
  ..FFFF..W.......c................................W..........
  ..FFFF..W........................................W..........
  ..FFFF.................GG........GG.......c......W..........
  ..FFFF.................GG..MMMM..GG..............W..........
  ..FFFF.................GG..MMMM..GG..............W.......MMM
  ..FFFF.................GG..MMMM..GG..............W.......MMM
  ........W..............GG..MMMM..GG..............W.......MMM
  ........W....GG...GG...GG..MMMM..GG..............W.......MMM
  ........W....GG...GG...GG..MMMM..GG......l.......W..........
  ........W....GG...GG...GG..MMMM..GG..............W..........
  ........W....GG...GG...GG..MMMM..GG..............W..........
  ........W....GG...GG...GG........GG..............W..........
  ........W....GG...GG.............................W..........
  ........W....GG...GG.............................W..........
  ........W.........GG.................GG.................bb..
  ........W............................GG.....................
  ........W............................GG....bb...............
  ........W............................GG....b................
  ......l.W.........l..............c...GG..........W..MM......
  ........W............................GG..........W..MM......
  ........W...b........................GG..........W.MMM......
  ........W...b........................GG..........W.MMM......
  ........W........................................W.MMM..c...
  ........W........................................W..........
  ........W.......c.................bb.............W..........
  ........W........................................W..........
  ........W........................................W..........
  ........WWWWWW....WWWWWWWWWWWWWWWWWWWW....WWWWWWWW..........
  ............................................................
  ..........MMM...............................................
  .........................................................m..
  ............................................................
  .....................MMM....................................
  ...XXXXX..........................GGGG......................
  ...XXXXX.................c........GGGG......................
  ...XXXXX..........................GGGG......................
  ...XXXXX..........................GGGG..........l...........
  ...XXXXX..............A....M......GGGG......................
  ...XXXXX...................M......GGGG......................
  ...XXXXX..........................GGGG......................
  ...XXXXX......................p...GGGG......................
  ...XXXXX..........................GGGG......................
  ...XXXXX.............MMM..........GGGG......................
  ............................................................
  ............c.................................c.............
  ............................................................
  ..........MMM...............................................
  ............................................................
  ........WWWWWWWWWWWW....WWWWWWWWWWWWWWWW....WWWWWW..........
  ........W........................................W..........
  ........W...............................a.....G..W..........
  ........W..FFFFF.....................MM.......G..W..........
  ........W..FFFFF......G.MMM..........MM.......G..W..........
  ........W..FFFFF......G.....................................
  ........W..FFFFF......G...WWWWWW............................
  ........W..FFFFF......G.....................................
  ........W.............G.....................................
  ........W........................................W..........
  ......l.WWWWWWWWWWWWWWWWWWWWWWWWWWWWWW......WWWWWW..........
  ........W........................................W..........
  ........W....MM........MM.........bb.............W..........
  ........W....MM........MM.........b..............W..........
  ............................MMcMM............G...W..........
  .............................................G...W..........
  .................................MM..........G...W..........
  ..................WWWWW..........MM..........G...W..........
  ........W.................g..................G...W..........
  ........W........................................W..........
  ........WWWW......WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW..........
  ........W........................................W..........
  ........W......................MM.......MMMM................
  ........W......................MM.......MMMM................
  ..FFFF..W...........MMMMM...............MMMM.c..............
  ..FFFF..W...................................................
  ..FFFF..W.......MM...MM..........................W..........
  ..FFFF..W.......MM...MM....c.....................W..........
  ..FFFF..W.............................o..........W..........
  ..FFFF..W........................................W..........
  ........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWW......WWWWWW..........
  ........W........................................W..........
  ........W.CCCCCCCCCCCCC.................FFFFF....W..........
  ........W.C.............................FFFFF....W..........
  ........W.C............G................FFFFF...............
  ........W.C............G....bb..........FFFFF...............
  ........W.C...CCCCCC...G................FFFFF.c.............
  ........W.C............G....................................
  ........W.C...i........G......MMMMMMM............W..........
  ........W.C......................................W..........
  ........W........................................W..........
  ........WWWWWW....WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW..........
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
`, 'museum');

export const MUSEUM = withGeometry(MUSEUM_GRID, MUSEUM_GEO);

const CELL = 50;
const SIZE = MUSEUM_GRID.size;
type Box = { x: number; y: number; w: number; h: number };
/** Cell corners (inclusive) to a pixel rect. */
const cells = (c0: number, r0: number, c1: number, r1: number): Box => ({ x: c0 * CELL, y: r0 * CELL, w: (c1 - c0 + 1) * CELL, h: (r1 - r0 + 1) * CELL });
const turnBox = (b: Box): Box => ({ x: SIZE - b.x - b.w, y: SIZE - b.y - b.h, w: b.w, h: b.h });
const withTurns = <T>(west: readonly T[], turn: (t: T) => T): T[] => [...west, ...west.map(turn)];

export type MuseumFloorKind = 'marble' | 'parquet' | 'carpet' | 'tile' | 'vault' | 'sand' | 'treasury' | 'slate' | 'concrete' | 'terrazzo' | 'ice' | 'space' | 'ocean' | 'lab' | 'kids' | 'dock';
export type DistrictId = 'egypt' | 'gems' | 'treasury' | 'armour' | 'impress' | 'modern' | 'sculpt' | 'shop' | 'cafe' | 'iceage' | 'space' | 'oceans' | 'lab' | 'kids' | 'dock' | 'entrance' | 'gemhall' | 'giants' | 'nhall' | 'shall' | 'rotunda' | 'grounds';
export type MuseumFloor = Box & { kind: MuseumFloorKind };
export type MuseumExit = { x: number; y: number; vertical: boolean };
export type MuseumBeam = { x1: number; y1: number; x2: number; y2: number; dead?: true };
export type District = Box & { id: DistrictId; name: string; floor: MuseumFloorKind | null; inset: boolean; /** Wash over the floor and the colour of its lights. */ wash: string; light: string };
export type MuseumSign = { text: string; x: number; y: number; vertical?: boolean; small?: true };

const D = (id: DistrictId, name: string, r: Box, floor: MuseumFloorKind | null, inset: boolean, wash: string, light: string): District => ({ id, name, ...r, floor, inset, wash, light });

/**
 * The map's districts, most specific first: what a player standing anywhere should be able to name without a minimap. Twin
 * halves of the grid are different places: decor, floors and light differ even where walls and cover are half-turns.
 */
export const DISTRICTS: readonly District[] = [
  D('gems', 'GEM VAULT', cells(40, 9, 48, 19), 'vault', true, '60, 110, 255', '#6fa8ff'),
  D('treasury', 'TREASURY', cells(71, 100, 79, 110), 'treasury', true, '255, 90, 60', '#ffb04a'),
  D('egypt', 'EGYPT', cells(8, 8, 49, 49), 'sand', true, '255, 160, 60', '#ff9a4a'),
  D('armour', 'ARMOUR HALL', cells(70, 70, 111, 111), 'slate', true, '230, 90, 70', '#ff8a4a'),
  D('impress', 'IMPRESSIONISTS', cells(8, 70, 49, 80), 'parquet', true, '255, 190, 120', '#ffd9a0'),
  D('modern', 'MODERN ART', cells(8, 81, 49, 90), 'concrete', true, '170, 210, 255', '#e8f2ff'),
  D('sculpt', 'SCULPTURE', cells(8, 91, 49, 100), 'terrazzo', true, '255, 235, 200', '#fff0d0'),
  D('shop', 'GIFT SHOP', cells(8, 101, 25, 111), 'carpet', true, '255, 120, 110', '#ffbf6a'),
  D('cafe', 'CAFE', cells(26, 101, 49, 111), 'tile', true, '255, 220, 150', '#ffd18a'),
  D('iceage', 'ICE AGE', cells(70, 39, 111, 49), 'ice', true, '140, 200, 255', '#bfe4ff'),
  D('space', 'SPACE', cells(70, 29, 111, 38), 'space', true, '120, 90, 255', '#9a8cff'),
  D('oceans', 'OCEANS', cells(70, 19, 111, 28), 'ocean', true, '40, 200, 200', '#5fe0d0'),
  D('lab', 'RESTORATION LAB', cells(94, 8, 111, 18), 'lab', true, '255, 255, 230', '#fffbe8'),
  D('kids', "KIDS' CORNER", cells(70, 8, 93, 18), 'kids', true, '255, 200, 80', '#ffe08a'),
  D('dock', 'LOADING DOCK', cells(0, 50, 13, 69), null, false, '255, 170, 40', '#ffb347'),
  D('entrance', 'MAIN ENTRANCE', cells(106, 50, 119, 69), null, false, '255, 230, 190', '#ffe3b0'),
  D('rotunda', 'ROTUNDA', { x: 2300, y: 2300, w: 1400, h: 1400 }, null, false, '255, 220, 150', '#ffd9a0'),
  D('gemhall', 'HALL OF GEMS', cells(14, 50, 43, 69), null, false, '120, 190, 255', '#bfe8ee'),
  D('giants', 'HALL OF GIANTS', cells(76, 50, 105, 69), null, false, '255, 200, 120', '#ffd9a0'),
  D('nhall', 'GREAT HALL', cells(50, 8, 69, 49), null, false, '255, 215, 140', '#ffd9a0'),
  D('shall', 'OCEAN HALL', cells(50, 70, 69, 111), null, false, '90, 170, 230', '#a8dcff'),
];
export const GROUNDS: District = D('grounds', 'THE GROUNDS', cells(0, 0, 119, 119), null, false, '100, 120, 160', '#9ab4e0');

/** The district a point stands in. */
export function districtAt(x: number, y: number): District {
  for (const d of DISTRICTS) {
    if (d.id === 'rotunda') { if (Math.hypot(x - SIZE / 2, y - SIZE / 2) < 700) return d; continue; }
    if (x >= d.x && x < d.x + d.w && y >= d.y && y < d.y + d.h) return d;
  }
  return GROUNDS;
}

/** The floors painted over the flagstone grounds: the marble cross first, then each district with a floor of its own. */
export const FLOORS: readonly MuseumFloor[] = [
  { kind: 'marble', ...cells(8, 50, 111, 69) },
  { kind: 'marble', ...cells(50, 8, 69, 111) },
  ...DISTRICTS.flatMap((d) => (d.floor ? [{ kind: d.floor, ...(d.inset ? { x: d.x + CELL, y: d.y + CELL, w: d.w - 2 * CELL, h: d.h - 2 * CELL } : d) }] : [])),
];

/** Signs hung over the doors, naming where you are going. */
export const SIGNS: readonly MuseumSign[] = [
  { text: 'EGYPT', x: 800, y: 2475 }, { text: 'EGYPT', x: 2000, y: 2475 }, { text: 'EGYPT', x: 2475, y: 900, vertical: true }, { text: 'EGYPT', x: 2475, y: 1900, vertical: true },
  { text: 'ARMOUR HALL', x: 4000, y: 3475 }, { text: 'ARMOUR HALL', x: 5200, y: 3475 }, { text: 'ARMOUR HALL', x: 3525, y: 5075, vertical: true }, { text: 'ARMOUR HALL', x: 3525, y: 4075, vertical: true },
  { text: 'IMPRESSIONISTS', x: 1150, y: 3475 }, { text: 'IMPRESSIONISTS', x: 2150, y: 3475 }, { text: 'SCULPTURE', x: 2475, y: 4700, vertical: true }, { text: 'SHOP & CAFE', x: 2475, y: 5300, vertical: true },
  { text: 'ICE AGE', x: 3900, y: 2475 }, { text: 'ICE AGE', x: 4900, y: 2475 }, { text: 'OCEANS', x: 3525, y: 1300, vertical: true }, { text: 'LAB & KIDS', x: 3525, y: 700, vertical: true },
  { text: 'GEM VAULT', x: 2250, y: 975, small: true }, { text: 'TREASURY', x: 3750, y: 5025, small: true },
];

/** Emergency exit signs hang over the doors to the grounds. */
export const EXITS: readonly MuseumExit[] = withTurns<MuseumExit>([
  { x: 1400, y: 425, vertical: false }, { x: 425, y: 1300, vertical: true },
  { x: 800, y: 5575, vertical: false }, { x: 425, y: 4300, vertical: true },
], (e) => ({ ...e, x: SIZE - e.x, y: SIZE - e.y }));

/** Harmless red security beams: a gate in each vault and a loop round each Hall of Gems case. The treasury's have been cut. */
export const BEAMS: readonly MuseumBeam[] = [
  { x1: 2055, y1: 810, x2: 2395, y2: 810 }, { x1: 2055, y1: 860, x2: 2395, y2: 860 }, { x1: 2055, y1: 780, x2: 2395, y2: 900 },
  { x1: 1655, y1: 2705, x2: 1945, y2: 2705 }, { x1: 1655, y1: 3295, x2: 1945, y2: 3295 }, { x1: 1655, y1: 2705, x2: 1655, y2: 3295 }, { x1: 1945, y1: 2705, x2: 1945, y2: 3295 },
  ...[
    { x1: 2055, y1: 810, x2: 2395, y2: 810 }, { x1: 2055, y1: 860, x2: 2395, y2: 860 }, { x1: 2055, y1: 780, x2: 2395, y2: 900 },
  ].map((b) => ({ x1: SIZE - b.x1, y1: SIZE - b.y1, x2: SIZE - b.x2, y2: SIZE - b.y2, dead: true as const })),
  ...[
    { x1: 1655, y1: 2705, x2: 1945, y2: 2705 }, { x1: 1655, y1: 3295, x2: 1945, y2: 3295 }, { x1: 1655, y1: 2705, x2: 1655, y2: 3295 }, { x1: 1945, y1: 2705, x2: 1945, y2: 3295 },
  ].map((b) => ({ x1: SIZE - b.x1, y1: SIZE - b.y1, x2: SIZE - b.x2, y2: SIZE - b.y2 })),
];
